// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cda0fb2d","453":"1b2aea45","455":"b7063cbb","938":"d61a69c0","977":"fde7dfcc"}[chunkId] + ".chunk.js";
};